import es6Promise from 'es6-promise';
import '@component_path/pages/pc/shared/search_histories';
import '@component_path/pages/pc/top/search_condition_box';
import '@component_path/pages/pc/top/search_module';
import '@component_path/vendor/m3common/jquery.cookie';

document.addEventListener('DOMContentLoaded', () => {
  es6Promise.polyfill();
});